import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { useState } from 'react';
import { Grid, GridItem, TextStyled, ButtonStyled } from '@nike/nike-design-system-components';
import { nike } from '@nike/nike-design-tokens';
import styled from '@emotion/styled';
import { useStadium } from 'stadium/StadiumHooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var cellStyle = {
  width: '100%',
  minHeight: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '2px'
};

// @ts-expect-error
var Cell = function Cell(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    style: cellStyle,
    children: children
  });
};
var GridItemWrapper = styled(GridItem)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .nds-grid-container {\n    height: auto !important;\n  }\n"])));

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var SalesInformation = function SalesInformation(props) {
  var xfPath = props.xfPath,
    isSalesInformationPage = props.isSalesInformationPage,
    viewAllText = props.viewAllText,
    placement = props.placement,
    _props$root = props.root,
    leftColumnDocuments = _props$root.leftColumnDocuments,
    rightColumnDocuments = _props$root.rightColumnDocuments,
    _props$hasMultipleSal = props.hasMultipleSalesInformationWidgets,
    hasMultipleSalesInformationWidgets = _props$hasMultipleSal === void 0 ? false : _props$hasMultipleSal,
    _props$isVisualizer = props.isVisualizer,
    isVisualizer = _props$isVisualizer === void 0 ? false : _props$isVisualizer,
    linkHost = props.linkHost,
    isAuthor = props.isAuthor;
  var _useStadium = useStadium(),
    sendInteractionEvent = _useStadium.analyticsHooks.sendInteractionEvent;
  var isFirstOnMultiComponentPage = props.isSalesInformationPage || props.root.isFirstOnMultiComponentPage;
  var title = props.title || props['jcr:title'];
  var cutInitValue = !props.isSalesInformationPage && !props.isAuthor && (props.root.leftColumnDocuments.item3 || props.root.rightColumnDocuments.item3);
  var _useState = useState(cutInitValue),
    _useState2 = _slicedToArray(_useState, 2),
    cut = _useState2[0],
    setCut = _useState2[1];

  // @ts-expect-error
  var displayList = function displayList(list, linkHostValue, cutValue) {
    var style = isVisualizer ? {
      pointerEvents: 'none'
    } : {};
    var columnTitle = list.columnTitle;
    var documents = Object.keys(list).filter(function (item) {
      return item.startsWith('item');
    }).filter(function (item, idx) {
      if (!cutValue) return item;
      if (cutValue && idx < 3) return item;
      return false;
    }).map(function (item) {
      return {
        title: list[item].title,
        path: list[item].urlLink || list[item].fileReference
      };
    });
    return /*#__PURE__*/_jsxs(Grid, {
      style: {
        backgroundColor: nike.podiumCdsColorWhite,
        height: 'auto',
        alignContent: 'baseline',
        padding: '4.5px 18px'
      },
      exteriorGapXs: "12px",
      rowGapXs: "18px",
      placeholder: undefined,
      onPointerEnterCapture: undefined,
      onPointerLeaveCapture: undefined,
      children: [/*#__PURE__*/_jsx(GridItem, {
        style: {
          borderBottom: "1px solid ".concat(nike.podiumCdsButtonColorBorderPrimary)
        },
        xs: 12,
        children: /*#__PURE__*/_jsx(TextStyled, {
          appearance: "title4",
          style: {
            textTransform: 'uppercase',
            font: 'var(--podium-cds-typography-960-plus-editorial-body1-strong)'
          },
          children: columnTitle
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        xs: 12,
        children: /*#__PURE__*/_jsx(Grid, {
          exteriorGapXs: "12px",
          rowGapXs: "4px",
          style: {
            margin: '12px 0',
            height: 'auto'
          },
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: documents.map(function (item) {
            var _item$path;
            return /*#__PURE__*/_jsx(GridItem, {
              xs: 12,
              style: {
                padding: '2px 0'
              },
              children: /*#__PURE__*/_jsx(ButtonStyled, {
                onClick: function onClick() {
                  sendInteractionEvent("homepage:".concat(placement, ":").concat(xfPath, ":").concat(item.title, ":").concat(item.path));
                },
                "data-testid": "item-link",
                appearance: "text",
                background: "light",
                size: "small",
                Component: "a",
                href: item !== null && item !== void 0 && (_item$path = item.path) !== null && _item$path !== void 0 && _item$path.includes('http') ? item.path : "".concat(linkHostValue).concat(item.path),
                target: "_blank"
                // @ts-expect-error
                ,
                style: style,
                children: item.title
              })
            }, "".concat(item.path, "_").concat(item.title));
          })
        })
      })]
    });
  };
  return /*#__PURE__*/_jsxs(Grid, {
    style: {
      backgroundColor: nike.podiumCdsColorGrey50,
      paddingBottom: '40px'
    },
    rowGapXs: "12px",
    exteriorGapXs: "0px",
    placeholder: undefined,
    onPointerEnterCapture: undefined,
    onPointerLeaveCapture: undefined,
    children: [/*#__PURE__*/_jsx(GridItem, {
      xs: 12,
      style: {
        padding: '35px 0'
      },
      children: /*#__PURE__*/_jsx(Cell, {
        children: (isFirstOnMultiComponentPage || !isSalesInformationPage) && !isAuthor ? /*#__PURE__*/_jsx(TextStyled, {
          appearance: "display4",
          style: {
            font: 'var(--podium-cds-typography-320-to-959-display3)'
          },
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: title
        }) : null
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      xs: 2
    }), /*#__PURE__*/_jsx(GridItemWrapper, {
      xs: 4,
      style: {
        marginRight: 3,
        backgroundColor: nike.podiumCdsColorWhite
      },
      children: displayList(leftColumnDocuments, linkHost, cut)
    }), /*#__PURE__*/_jsx(GridItemWrapper, {
      xs: 4,
      style: {
        marginLeft: 3,
        backgroundColor: nike.podiumCdsColorWhite
      },
      children: displayList(rightColumnDocuments, linkHost, cut)
    }), /*#__PURE__*/_jsx(GridItem, {
      xs: 2
    }), /*#__PURE__*/_jsx(GridItem, {
      xs: 12,
      children: /*#__PURE__*/_jsxs(Cell, {
        children: [hasMultipleSalesInformationWidgets && !isSalesInformationPage && /*#__PURE__*/_jsx(ButtonStyled, {
          appearance: "secondary",
          background: "light",
          type: "button",
          Component: "a",
          href: "/portal/salesinformation",
          disabled: isVisualizer,
          "data-testid": "button1",
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: viewAllText
        }), !hasMultipleSalesInformationWidgets && cut && !isSalesInformationPage && /*#__PURE__*/_jsx(ButtonStyled, {
          appearance: "secondary",
          background: "light",
          type: "button",
          "data-testid": "button2",
          onClick: function onClick() {
            return setCut(false);
          },
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: viewAllText
        })]
      })
    })]
  });
};
export default SalesInformation;